/**
 * Hooks para email_log (audit trail).
 *
 * - useEmailLog(filter) — list paginado con filtros (refetch on filter change).
 * - useResendEmail() — mutation para POST /resend (501 hasta D.4).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import {
  emailLogApi,
  type EmailLogFilter,
  type EmailLogListResponse,
} from '@/lib/api-email-templates'

export function useEmailLog(filter: EmailLogFilter) {
  return useQuery<EmailLogListResponse>({
    // Filter completo en queryKey → cambios refetchean automáticamente.
    queryKey: ['admin', 'email-log', filter],
    queryFn: () => emailLogApi.list(filter),
    staleTime: 30 * 1000,
    placeholderData: (prev) => prev, // pagination smooth (sin spinner blanco)
  })
}

export function useResendEmail() {
  const qc = useQueryClient()
  return useMutation<{ message?: string }, Error, string>({
    mutationFn: (logId) => emailLogApi.resend(logId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'email-log'] })
      toast.success('Re-envío encolado')
    },
    onError: (err) => {
      const e = err as { response?: { status?: number; data?: { message?: string } } }
      const status = e?.response?.status
      const msg = e?.response?.data?.message || err.message
      if (status === 501) {
        toast.warning(`Re-envío automático todavía no está activo: ${msg}`)
      } else {
        toast.error(`No se pudo re-enviar: ${msg}`)
      }
    },
  })
}
